import React, { Fragment } from 'react';
import HeaderPortal from '../../../components/layout/HeaderPortal';
import ParameterListBrowser from './ParameterListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_INITIALIZATION_PARAMETERS } from 'constants/rightsCodes';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <PermissionCheck authorizationCode={ADMIN_INITIALIZATION_PARAMETERS}>
        <ParameterListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

export default Route;
